import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comGoodsRead/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const handleStatus = query => {  
    var list = request({
        url: 'comGoodsRead/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comGoodsRead/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comGoodsRead/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDeleteMore = query => {  
    var list = request({
        url: 'comGoodsRead/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comGoodsRead/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

export const fetchSelect = query => {  
    var list = request({
        url: 'comGoodsRead/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};




